import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useStore } from '../store/useStore';
import apiService from '../services/api';

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { clearCart } = useStore();
  const orderNumber = searchParams.get('order') || '';
  const [orderStatus, setOrderStatus] = useState<'checking' | 'confirmed' | 'unknown'>('checking');

  useEffect(() => {
    // Paytr'ın iframe'i bu sayfaya sadece iframe içinde yönlenir.
    // Kullanıcının üst pencerede net bir onay ekranı görmesi için
    // iframe'den çıkıp üst pencereyi aynı adrese yönlendiriyoruz.
    if (window.self !== window.top && window.top) {
      window.top.location.href = window.location.href;
      return;
    }

    // Üst pencerede olduğumuza göre sepeti temizleyip sipariş durumunu kontrol edebiliriz.
    clearCart();

    if (orderNumber) {
      apiService.getOrder(orderNumber).then((res) => {
        setOrderStatus(res.success && res.order ? 'confirmed' : 'unknown');
      });
    } else {
      setOrderStatus('unknown');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // İframe içindeyken (üst pencereye yönlendirme gerçekleşene kadar) boş bir yükleme ekranı göster
  if (window.self !== window.top) {
    return <div className="min-h-[200px]" />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white rounded-3xl shadow-xl p-12 text-center max-w-md mx-4">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="text-4xl">✅</span>
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Siparişiniz Alındı!</h2>
        <p className="text-gray-500 mb-4">
          {orderStatus === 'checking'
            ? 'Sipariş durumunuz kontrol ediliyor...'
            : 'Sipariş numaranız cep telefonu ve e-posta adresinize gönderilecektir.'}
        </p>
        {orderNumber && (
          <div className="bg-gray-50 border-2 border-dashed border-[#E31E24] rounded-xl px-6 py-4 mb-6">
            <p className="text-xs text-gray-500 mb-1">Sipariş Numaranız</p>
            <p className="text-xl font-black text-[#E31E24] tracking-wider">{orderNumber}</p>
          </div>
        )}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-[#E31E24] text-white font-bold rounded-xl hover:bg-[#c41a1f] transition-colors"
          >
            Alışverişe Devam Et
          </button>
          {orderNumber && (
            <button
              onClick={() => navigate('/kargo-takip')}
              className="px-6 py-3 bg-gray-100 text-gray-700 font-bold rounded-xl hover:bg-gray-200 transition-colors"
            >
              Siparişimi Takip Et
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
